function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var BaseModule = /*#__PURE__*/function () {
  function BaseModule(resizer) {
    _classCallCheck(this, BaseModule);

    this.resizer = resizer;
    this.quill = resizer.quill;
    this.overlay = resizer.overlay;
    this.activeEle = resizer.activeEle;
    this.blot = resizer.blot;
    this.options = resizer.options;

    this.requestUpdate = function () {
      resizer.onUpdate(true);
    };
  }
  /*
    requestUpdate (passed in by the library during construction, above) can be used to let the library know that
    you've changed something about the image that would require re-calculating the overlay (and all of its child
    elements)
      For example, if you add a margin to the element, you'll want to call this or else all the controls will be
    misaligned on-screen.
  */

  /*
    onCreate will be called when the element is clicked on
      If the module has any user controls, it should create any containers that it'll need here.
    The overlay has absolute positioning, and will be automatically repositioned and resized as needed, so you can
    use your own absolute positioning and the 'top', 'right', etc. styles to be positioned relative to the element
    on-screen.
  */


  _createClass(BaseModule, [{
    key: "onCreate",
    value: function onCreate() {}
    /*
      onDestroy will be called when the element is de-selected, or when this module otherwise needs to tidy up.
        If you created any DOM elements in onCreate, please remove them from the DOM and destroy them here.
    */

  }, {
    key: "onDestroy",
    value: function onDestroy() {}
    /*
      onUpdate will be called any time that the element is changed (e.g. resized, aligned, etc.)
        This frequently happens during resize dragging, so keep computations light while here to ensure a smooth
      user experience.
    */

  }, {
    key: "onUpdate",
    value: function onUpdate() {}
  }]);

  return BaseModule;
}();

export { BaseModule as default };